import { useState } from 'react';
import { getDisplayCountry, formatCalcDisplay } from '../data/countries';
import PageRefinedHero from '../components/layout/PageRefinedHero';

const CalculatorPage = ({ country }) => {
  const [investment, setInvestment] = useState(5000);
  const [years, setYears] = useState(5);
  const [returnRate, setReturnRate] = useState(12);
  const [monthlyAdd, setMonthlyAdd] = useState(500);
  const c = getDisplayCountry(country);

  const futureValue = () => {
    let total = investment;
    for (let i = 0; i < years; i++) {
      total = total * (1 + returnRate/100) + (monthlyAdd * 12);
    }
    return total;
  };
  const fv = futureValue();
  const totalContributed = investment + (monthlyAdd * 12 * years);

  return (
    <div className="coown-page coown-page--hero">
      <PageRefinedHero
        badge="Plan your portfolio"
        title="Investment"
        titleAccent="calculator"
        subtitle={`Model compound growth for fractional real estate in ${c.name}. Adjust contributions, horizon, and expected return — shown in ${c.symbol} and USD.`}
        benefits={[
          { icon: 'fas fa-sliders-h', title: 'Live scenarios', subtitle: 'Slide inputs and see projections update' },
          { icon: 'fas fa-coins', title: 'Dual currency', subtitle: 'Local display with USD reference' },
          { icon: 'fas fa-chart-line', title: 'Wealth horizon', subtitle: 'Plan from 1 to 30 years ahead' },
        ]}
      />

      <div className="coown-page-body coown-page-body--narrow">
        <div className="detail-card" style={{ marginBottom: '1.25rem' }}>
          <div className="form-row">
            <div className="form-group">
              <label>Initial Investment</label>
              <input type="number" value={investment} onChange={(e)=>setInvestment(parseFloat(e.target.value)||0)} />
            </div>
            <div className="form-group">
              <label>Monthly Contribution</label>
              <input type="number" value={monthlyAdd} onChange={(e)=>setMonthlyAdd(parseFloat(e.target.value)||0)} />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Expected Annual Return (%)</label>
              <input type="range" min="5" max="25" value={returnRate} onChange={(e)=>setReturnRate(parseInt(e.target.value))} />
              <div style={{textAlign:"center",fontWeight:700,color:"var(--primary)"}}>{returnRate}%</div>
            </div>
            <div className="form-group">
              <label>Time Horizon (Years)</label>
              <input type="range" min="1" max="30" value={years} onChange={(e)=>setYears(parseInt(e.target.value))} />
              <div style={{textAlign:"center",fontWeight:700,color:"var(--primary)"}}>{years} years</div>
            </div>
          </div>
        </div>

        <div className="calc-results-panel">
          <div className="calc-results-panel__label">Projected portfolio value</div>
          <h2 className="calc-results-panel__value">
            {formatCalcDisplay(fv, country)}{' '}
            <span className="calc-results-panel__usd">(${Math.round(fv).toLocaleString()} USD)</span>
          </h2>
          <div className="calc-results-panel__stats">
            <div>
              <div className="calc-results-panel__stat-label">Total contributed</div>
              <div className="calc-results-panel__stat-value">{formatCalcDisplay(totalContributed, country)}</div>
            </div>
            <div>
              <div className="calc-results-panel__stat-label">Total returns</div>
              <div className="calc-results-panel__stat-value">{formatCalcDisplay(Math.max(0, fv - totalContributed), country)}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalculatorPage;
